import React from "react"

import { Grid } from "@material-ui/core"

import { Text } from "letalkui"

import { ActionDialog } from "@/components"
import {
	INSTANCES_WITH_MERLIN_WARNING_DEADLINE_IN_29_07_2026,
	INSTANCES_WITH_MERLIN_WARNING_DEADLINE_IN_15_09_2026
} from "@/services/HardCoded"

const MERLIN_NON_OWNER_WARNING_TITLE = "Formulário de onboarding pendente"

const getMerlinNonOwnerWarningMessage = (deadline: string): string =>
	`Identificamos que o formulário de onboarding ainda não foi preenchido pelo responsável da conta. Entre em contato com o dono da conta para que ele preencha o formulário até ${deadline}. Caso contrário, a operação da plataforma poderá ser interrompida.`

const MERLIN_NON_OWNER_WARNING_DEADLINE_GROUPS: Record<string, number[]> = {
	"29/07/2026": [...INSTANCES_WITH_MERLIN_WARNING_DEADLINE_IN_29_07_2026],
	"15/09/2026": [...INSTANCES_WITH_MERLIN_WARNING_DEADLINE_IN_15_09_2026]
}

const findDeadlineByInstanceId = (instanceId: number): string | undefined => {
	const deadlineEntry = Object.entries(MERLIN_NON_OWNER_WARNING_DEADLINE_GROUPS).find(
		([, instanceIds]) => instanceIds.includes(instanceId)
	)

	return deadlineEntry?.[0]
}

export const openMerlinNonOwnerWarningDialog = (instanceId: number): void => {
	const deadline = findDeadlineByInstanceId(instanceId)

	if (!deadline) {
		return
	}

	ActionDialog.open({
		title: MERLIN_NON_OWNER_WARNING_TITLE,
		openDialog: true,
		hideCloseButton: true,
		hideCloseIcon: true,
		saveText: "ESTOU CIENTE",
		forcedRender: true,
		onSave: () => undefined,
		children: (
			<Grid container direction="column" spacing={2}>
				<Grid item>
					<Text.Body type="default">
						{getMerlinNonOwnerWarningMessage(deadline)}
					</Text.Body>
				</Grid>
			</Grid>
		)
	})
}
